import React, { useState, useRef } from "react";
import classes from "./style.module.scss";
import { icons } from "helpers/images";
import { useOnOutsideClick } from 'hooks/useOutsideClick';

const FilterBy = (props) => {

  const [dropdown, setDropdown] = useState(false);
  const { innerBorderRef } = useOnOutsideClick((e) => {
    setDropdown(false)
  } );
  const { label, filterDropdownOptions, onChangeFilter ,clearFilter } = props;

  const applyFilter = (data) => {
    onChangeFilter(data);
  };

  return (
    <div className={classes.filterBlock}>
      <div
        className={classes.filterContainer}
        onClick={(e) => {
          setDropdown(!dropdown);
        }}
      >
        <img alt="dot" src={icons.fitler} className={classes.filterIcon} />
        {label}
        {dropdown && (
          <div
            className={classes.dropdown}
            ref={innerBorderRef}
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            {filterDropdownOptions.map((ele) => (
              <div className={classes.dropdownRow}>
                {" "}
                <div className="me-3">
                  <input
                    id={"checkbox"}
                    type={"checkbox"}
                    onChange={(e) => applyFilter(ele?.value)}
                    className={classes.checkbox}
                  />
                </div>
                <div className={classes.dropdownLabel}>{ele?.label}</div>
              </div>
            ))}
          </div>
        )}
      </div>

      <div className={classes.clearFilterContainer} onClick={clearFilter}>X Clear Filter</div>
    </div>
  );
};

export default FilterBy;
